import { render, staticRenderFns } from "./TouchpointOverview.vue?vue&type=template&id=6d53ad01&scoped=true&"
import script from "./TouchpointOverview.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverview.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointOverview.vue?vue&type=style&index=0&id=6d53ad01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53ad01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d53ad01')) {
      api.createRecord('6d53ad01', component.options)
    } else {
      api.reload('6d53ad01', component.options)
    }
    module.hot.accept("./TouchpointOverview.vue?vue&type=template&id=6d53ad01&scoped=true&", function () {
      api.rerender('6d53ad01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointOverview.vue"
export default component.exports